<template>
  <div id="agentmanage">
    <mt-cell :title="returnRate" ></mt-cell>
    <div style="    height: 1px;border-bottom: solid 1px rgba(128, 128, 128, 0.39)"></div>
    <mt-cell :title="this.$store.getters.WordsConfig.Index.dayIncome" value>
      <div>
        <span>{{ this.$store.getters.IndexTable.TodayUserProfit}}</span>
        <!-- <i class="mint-cell-allow-right"></i> -->
      </div>
    </mt-cell>
    <mt-cell :title="this.$store.getters.WordsConfig.Index.dayIncome" value>
      <div>
        <span>{{ this.$store.getters.IndexTable.TodayUserProfit}}</span>
        <!-- <i class="mint-cell-allow-right"></i> -->
      </div>
    </mt-cell>
    <mt-cell :title="this.$store.getters.WordsConfig.Index.monthIncome" value>
      <div>
        <span>{{ this.$store.getters.IndexTable.MonthUserProfit}}</span>
        <!-- <i class="mint-cell-allow-right"></i> -->
      </div>
    </mt-cell>
    <mt-cell :title="this.$store.getters.WordsConfig.Index.returnRate" value>
      <div>
        <span>{{ (this.$store.getters.IndexTable.Rebates * 100) + '%'}}</span>
        <!-- <i class="mint-cell-allow-right"></i> -->
      </div>
    </mt-cell>
    <mt-cell :title="this.$store.getters.WordsConfig.Index.canWithdraw" value>
      <div>
        <span>{{ this.$store.getters.IndexTable.Cashable}}</span>
        <!-- <i class="mint-cell-allow-right"></i> -->
      </div>
    </mt-cell>



    </table>
  </div>
</template>

<script>
  import { G_SubP } from "../../api/api";
  export default {
    data() {
      return {
        table: [],
        table_height: 0
      };
    },
    created() {
      //TODO 获取下线推广列表
      this.getData(0);
    },
    methods: {
      getData(page) {
        G_SubP(page)
          .then(result => {
            console.log(
              "======================获取代理管理======================"
            );
            let d = [];
            d = result;
            this.getSubP(d);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getSubP(arr) {
        let data = [];
        for (let it of arr) {
          let agent = {
            agent_id: it.PromoterCode,
            agent_name: it.UserName,
            agent_income: it.MonthAward,
            agent_history: it.Award,
            agent_bindtime: it.BindDate
          };
          this.table.push(agent);
        }
      },
      getNextPage(currPage) {
        this.table = [];
        this.getData(currPage - 1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  #agentmanage {
    height: 100%;
    overflow: hidden;
  }

  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/ReturnRate.vue